
import { Component, Prop, Vue } from 'vue-property-decorator'

import { createEmptyAddress, DeliveryAddress } from '../types/enrollmentForm'

@Component({ name: 'DeliveryAddressList' })
export default class extends Vue {
  @Prop({ required: true }) addresses!: DeliveryAddress[]
  @Prop({ default: 'deliveryAddresses' }) propPrefix!: string
  @Prop({ default: true }) allowEmpty!: boolean
  @Prop({ default: false }) showPrefillNotice!: boolean
  @Prop({ default: '' }) emptyHint!: string
  @Prop({ default: true }) allowRemovePrefilled!: boolean

  get addressRules() {
    const required = (key: string) => [{ required: true, message: this.$t(key), trigger: 'blur' }]
    return {
      siteName: required('enrollment.rules.siteName'),
      street: required('enrollment.rules.street'),
      city: required('enrollment.rules.city'),
      zipcode: required('enrollment.rules.zipcode')
    }
  }

  deletable(address: DeliveryAddress): boolean {
    if (this.addresses.length <= 1 && !this.allowEmpty) return false
    if (address.prefilled && !this.allowRemovePrefilled) return false
    return true
  }

  addAddress(): void {
    this.addresses.push(createEmptyAddress())
  }

  removeAddress(index: number): void {
    this.addresses.splice(index, 1)
  }
}
